module.exports = __webpack_public_path__ + "static/roxana-mocanu-e4b21500cdee24671ace3dedd55cedf7.jpg";